import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {BasicSymbol, SymbolStates} from "../../reels/symbols/BasicSymbol";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ScatterSymbol} from "../../reels/symbols/ScatterSymbol";
import {XWaySymbol} from "../../reels/symbols/XWaySymbol";
import {XSplitSymbol} from "../../reels/symbols/XSplitSymbol";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";


export class StickyLockPresentation implements SimplePresentation {
    name: string = "StickyLockPresentation";
    private _stickyTl: gsap.core.Timeline;

    shouldRun(): boolean {
        return (XwaysHoarder2.model.isRespinStarting || XwaysHoarder2.model.isRespinGameSpin) && !XwaysHoarder2.model.isRespinEnding && !XwaysHoarder2.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._stickyTl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish();
            }
        });


        let lockSoundPlayed: boolean = false;
        for (let reelNo: number = 1; reelNo < 6; reelNo++) {

            [0, 1, 2].forEach((symNo: number) => {
                const currentSym: BasicSymbol = <BasicSymbol>XwaysHoarder2.reelView.reels[reelNo].model.getVisibleSymbolAt(symNo).positionable;
                if (currentSym.symbolName === "XW") {
                    if (currentSym.state !== SymbolStates.STICKY) {
                        this._stickyTl.add((<XWaySymbol>currentSym).getStateAnimation(SymbolStates.STICKY), 0);
                        if (!lockSoundPlayed) {
                            this._stickyTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.TAPE_ON);
                            }, "<");
                            lockSoundPlayed = true;
                        }
                        XwaysHoarder2.reelView.reels[reelNo].lockSpecialSymAndAddDummyBelow(symNo, "D", true);
                    }
                }
                if (currentSym.symbolName === "XS") {
                    if (currentSym.state !== SymbolStates.STICKY) {
                        this._stickyTl.add((<XSplitSymbol>currentSym).getStateAnimation(SymbolStates.STICKY), 0);
                        if (!lockSoundPlayed) {
                            this._stickyTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.TAPE_ON);
                            }, "<");
                            lockSoundPlayed = true;
                        }
                        XwaysHoarder2.reelView.reels[reelNo].lockSpecialSymAndAddDummyBelow(symNo, "D", true);
                    }
                }
                if (currentSym.symbolName === "SC" || currentSym.symbolName === "SSC") {
                    if (XwaysHoarder2.model.gameData.nextMode === GameMode.RESPIN) {
                        if (currentSym.state !== SymbolStates.STICKY) {
                            this._stickyTl.add((<ScatterSymbol>currentSym).getStateAnimation(SymbolStates.STICKY), 0);
                            if (!lockSoundPlayed) {
                                this._stickyTl.add(() => {
                                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.TAPE_ON);
                                }, "<");
                                lockSoundPlayed = true;
                            }
                            XwaysHoarder2.reelView.reels[reelNo].lockSpecialSymAndAddDummyBelow(symNo, "D", true);
                        }
                    }
                }

            });
        }

        controller.setSkipCallback(() => this.onStickySkip());

    }

    private onStickySkip(): void {
        if (XwaysHoarder2Sound.soundPlayer.fetchSoundPlayer(XwaysHoarder2Sound.TAPE_ON)?.isPlaying) {
            XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.TAPE_ON);
        }
        this._stickyTl.totalProgress(1);
    }
}